import React from "react";
import { useTranslation } from "react-i18next";

// Matches Diamond-PO-Prototype-v3.html's stPill()/LBL/.st-* classes exactly (colors + labels
// ported 1:1 from the prototype's CSS, lines 124-247, and its LBL map, lines 555-558).

const COLORS = {
  AVAILABLE: { bg: "#e7f6ef", fg: "#1c8b57" },
  HELD: { bg: "#fdf3e3", fg: "#a3701a" },
  MEMO: { bg: "#e8effc", fg: "#2a52b8" },
  SOLD: { bg: "#e3e7ef", fg: "#1f2a44" },
  DRAFT: { bg: "#eef1f8", fg: "#5c6885" },
  REQUESTED: { bg: "#fdf3e3", fg: "#a3701a" },
  OUT: { bg: "#e8effc", fg: "#2a52b8" },
  OVERDUE: { bg: "#fdecea", fg: "#c0392b" },
  PARTIAL: { bg: "#e9f7f4", fg: "#0f766e" },
  CLOSED: { bg: "#e3e7ef", fg: "#1f2a44" },
  RETURNED: { bg: "#eef1f8", fg: "#5c6885" },
  DECLINED: { bg: "#eef1f8", fg: "#5c6885" },
  PARTSHIP: { bg: "#fff1e0", fg: "#a3701a" },
  DISCREPANCY: { bg: "#fdf3e3", fg: "#b5621a" },
  RETURN_REQUESTED: { bg: "#fdf3e3", fg: "#a3701a" },
  RETURNING: { bg: "#eef1f8", fg: "#3d4a6b" },
  SHIPPED: { bg: "#e8effc", fg: "#2a52b8" },
  DELIVERED: { bg: "#e9f7f4", fg: "#0f766e" },
  ACCEPTED: { bg: "#e7f6ef", fg: "#1c8b57" },
  COMPLETED: { bg: "#e7f6ef", fg: "#1c8b57" },
  RETURN: { bg: "#fdf3e3", fg: "#a3701a" },
};

const LABEL_KEYS = {
  AVAILABLE: "Available",
  HELD: "On hold",
  MEMO: "On memo",
  SOLD: "Sold",
  RETURNING: "Return in transit",
  REQUESTED: "Requested",
  PARTSHIP: "Part shipped",
  OUT: "On memo",
  OVERDUE: "Overdue",
  PARTIAL: "Part settled",
  CLOSED: "Closed",
  DISCREPANCY: "Discrepancy",
  RETURNED: "Returned",
  DECLINED: "Declined",
  RETURN_REQUESTED: "Return requested",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered",
  COMPLETED: "Completed",
  ACCEPTED: "Accepted",
  RETURN: "Return open",
  INACTIVE: "Not listed",
};

// CLOSED shows a checkmark, SOLD a lock -- everything else a plain dot (prototype .st:before).
const PREFIX = { CLOSED: "✓", SOLD: "🔒" };

export const DocStatusPill = ({ status }) => {
  const { t } = useTranslation();
  const c = COLORS[status] || { bg: "#eef1f8", fg: "#5c6885" };
  const label = LABEL_KEYS[status] ? t(LABEL_KEYS[status]) : status;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontSize: 12,
        fontWeight: 700,
        padding: "3px 9px",
        borderRadius: 20,
        whiteSpace: "nowrap",
        background: c.bg,
        color: c.fg,
      }}
    >
      {PREFIX[status] ? (
        <span style={{ fontSize: 9 }}>{PREFIX[status]}</span>
      ) : (
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "currentColor", display: "inline-block" }} />
      )}
      {label}
    </span>
  );
};

export default DocStatusPill;
